import React, { Component } from 'react';
import { Checkbox } from '@rmwc/checkbox';
import { Radio } from '@rmwc/radio';
import { Select } from '@rmwc/select';
import Scrollbar from 'react-scrollbars-custom';
import { TextField } from '@rmwc/textfield';
import { Button, Tabs, Tab, Nav, Accordion, Card } from 'react-bootstrap';
import EditPriceItem from '../../EditPriceItem/EditPriceItem';
import CurrencyFormat from 'react-currency-format';
import Tax from './Tax';
import OrderNow from '../Common/OrderNow.js';
import { connect } from "react-redux";
import * as actionCreator from "../../../action/index.js";
import * as cuComponent from '../../../redux/reducers/building_component/componentReducer.js';
import * as validate from '../../Modals/validations';
import ReadMore  from '../../ReadMore'
import TotalDiscount from '../Common/DepositOrder/TotalDiscount.js';
import Total from '../Common/DepositOrder/Total.js';
import Deposit from '../Common/DepositOrder/Deposit.js';
import DepositDiscount from '../Common/DepositOrder/DepositDiscount.js';
let surchargePrice = 0;
class TaxDeposit extends Component {
  
  render() {
    let manufacturer_discount =
    this.props.const_var.post_data.building != undefined &&
    this.props.const_var.post_data.building.discount_amount != undefined &&
    this.props.const_var.post_data.building.discount_amount != 0;

    let dealer_discount =
    this.props.const_var.post_data.building != undefined &&
    this.props.const_var.post_data.building.down_payment_discount_total !=
      undefined &&
    this.props.const_var.post_data.building.down_payment_discount_total !=
      0 &&
    this.props.const_var.BuildingPriceArrar["down_payment_discount_total"] !=
      0;

    if (this.props.order_extra_items.surchargeFees == 0 && this.props.const_var.post_data.building != undefined && this.props.const_var.crmSetting.is_Edit == true) {
      surchargePrice = (this.props.const_var.post_data.building.order_extra_items['surchargeFees']);
    } else {
      if (this.props.const_var.post_data.building != undefined) {
        surchargePrice = (this.props.const_var.post_data.building.order_extra_items['surchargeFees']);
      } else {
        surchargePrice = (this.props.order_extra_items.surchargeFees);
      }

    }
    if (isNaN(surchargePrice)) {
      surchargePrice = 0;
    }
    return (
      <div className="building-elements-sec deposit-section">
        <div className="building-elements-sec-mid pt-0">
          <div className="building-elements-sec-mid-scroll">
            <form>
              <div className="section-seprator">
                <div className='card-body-inner'>
                <Accordion className='accordion-pills' defaultActiveKey="manufacturer">
                    <Card className='card-pills active'>
                      <Card.Header className='card-headers-pills'>
                        <Accordion.Toggle as={Card.Header} eventKey="manufacturer" className='accordion-toggle-pills' onClick={(e) => this.props.handleAccordion(e)}>
                          <span className='card-pills-title'>Manufacturer Surcharge & Discount</span>
                          <span className='card-pills-action'><i className='icon icon-plus-ico'></i></span>
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="manufacturer" className='accordion-collapse-pills'>
                        <Card.Body className='card-body-pills'>
                          <div className='card-top-pills'>
                            <div class='form-group mb-0'>
                              <div class='control-label-bar'>
                                <label class='control-label'>Surcharge</label>                              
                              </div>
                              <div className={"floating-label-input"+ (!this.props.const_var.is_price_edit ? ' disable-edit' : '')}>
                                <TextField
                                  placeholder="Add Title here..."
                                  maxLength="8"
                                  onKeyUp={e => validate.numericCheckwithDecimalVal(e)}
                                  onChange={e => this.props.orderExtrasChangeValueFromMainAction(e, 'surchargeFees', 'yes')}
                                  value={surchargePrice}
                                  name="surchargeFees"
                                />
                              </div>
                            </div>
                          </div>

                          <div className='card-bottom-pills'>
                            <div class='form-group'>                              
                              <label class='control-label'>Manufacturer Discount</label>
                              <div class='control-label-action'>
                                  <div className="price-box-type-2">
                                    <span>${(this.props.const_var.post_data.building != undefined && this.props.const_var.post_data.building.discount_amount != undefined) ? this.props.const_var.post_data.building.discount_amount : 0}</span>                                    
                                  </div>
                                </div>
                              <div className='row align-items-center gutters-5'>
                                <div className='col-auto'>
                                  <div class={"input-group floating-label-input mw-130"+ (!this.props.const_var.is_price_edit ? ' disable-edit' : '')}>
                                    <TextField
                                      name="quantity"
                                      value={(this.props.const_var.post_data.building != undefined  && this.props.const_var.post_data.building.discount_amount != undefined && this.props.const_var.post_data.building.discount_amount != 0 ) ? this.props.const_var.post_data.building.discount_rate : 0}
                                      onKeyUp={e => validate.numericCheckwithDecimalVal(e)}
                                      onChange={e => this.props.TaxDepositCalculation(e.target.value, 'discount_rate', "quantity")}
                                    />
                                    <div class="input-group-append">
                                      <span class="input-group-text">
                                        <div className='toggle-checkgroup'>
                                          <input type="checkbox" id="manufactureDis" class="toggle-checkbox" checked={this.props.const_var.post_data.building.discount_type !== "per" ? true : false}/>
                                          <label for="manufactureDis" class='toggle-label-checkbox'>
                                            <div className='unit parcent' onClick={e => this.props.TaxDepositCalculation('%', 'discount_type', "type")}>%</div>   
                                            <div className='unit dollar' onClick={e => this.props.TaxDepositCalculation('$', 'discount_type', "type")}>$</div>
                                          </label>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className='col'>
                                  <div className='price-inline'>
                                    <span className='price-item price price-default'><del>{manufacturer_discount ? <Total /> : null}</del></span>
                                    <span className='price-item price price-primary'>{manufacturer_discount ?<TotalDiscount />: null}</span>
                                  </div>
                                </div>
                              </div>
                            </div>  

                            <div class='form-group'>
                              <div class='control-label-bar'>
                                <label class='control-label'>Title of the Discount</label>                            
                              </div>
                              <div className="floating-label-input">
                                <TextField
                                  placeholder='Discount Name'
                                  name="MFdiscounttypename"
                                  maxLength="20"
                                  value={this.props.const_var.manufacturer_discount_label}
                                  onChange={e => this.props.TaxDepositCalculation(e.target.value, 'MFdiscounttypename', "")}
                                />
                              </div>
                            </div> 
                            {/* Removed code according to the requirement */}
                            {/* <div class='form-group'>                              
                              <label class='control-label-text'>Specials</label>
                              <div className='tag-list'>
                                <div className='tag-item'><div className='tag'><div className='tag-inner'>$5k - $10K &gt;&gt; 20% Off</div></div></div>
                                <div className='tag-item'><div className='tag'><div className='tag-inner'>$15k - $20K &gt;&gt; 25% Off</div></div></div>
                              </div>
                            </div>  */}
                            <div className={this.props.discount_banner? 'view-more-discounts' : "d-none"} onClick={() => this.props.handleShowDiscountsModal()}><span className='text'>View offers</span><span className="icon-arrow-right-ico"></span></div>
                          </div>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>

                    {(this.props.const_var.crmSetting.is_module_name != "inventory") ?
                      <Card className='card-pills'>
                        <Card.Header className='card-headers-pills'>
                          <Accordion.Toggle as={Card.Header} eventKey="taxdetail" className='accordion-toggle-pills' onClick={(e) => this.props.handleAccordion(e)}>
                            <span className='card-pills-title'>Tax Details</span>
                            <span className='card-pills-action'><i className='icon icon-plus-ico'></i></span>
                          </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="taxdetail" className='accordion-collapse-pills'>
                          <Card.Body className='card-body-pills'>
                            <Tax />
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                      : null}

                    <Card className='card-pills'>
                      <Card.Header className='card-headers-pills'>
                        <Accordion.Toggle as={Card.Header} eventKey="dealerdeposit" className='accordion-toggle-pills' onClick={(e) => this.props.handleAccordion(e)}>
                          <span className='card-pills-title'>Dealer Deposit & Discount</span>
                          <span className='card-pills-action'><i className='icon icon-plus-ico'></i></span>
                        </Accordion.Toggle>
                      </Card.Header>

                      <Accordion.Collapse eventKey="dealerdeposit" className='accordion-collapse-pills'>
                        <Card.Body  className='card-body-pills'>
                          <div className='card-top-pills'>
                            <div class='form-group mb-0'>        
                              <label class='control-label'>Dealer Deposit</label>
                              <div className='row align-items-center'>
                                <div className='col-6'>
                                  <div class={"input-group floating-label-input"+ (!this.props.const_var.is_price_edit ? ' disable-edit' : '')}>
                                    <TextField
                                      placeholder="Dealer Deposit"
                                      name="quantity"
                                      value={(this.props.const_var.post_data.building != undefined) ? this.props.const_var.post_data.building.down_payment_rate : 0}
                                      onKeyUp={e => validate.numericCheckwithDecimalVal(e)}
                                      onChange={e => this.props.TaxDepositCalculation(e.target.value, 'down_payment_rate', "quantity")}
                                    />
                                    <div class="input-group-append">
                                      <span class="input-group-text">                                      
                                        <div className='toggle-checkgroup'>
                                          <input type="checkbox" id="dealerDiscont" class="toggle-checkbox" checked={this.props.const_var.post_data.building.down_payment_type !== "per" ? true : false}/>
                                          <label for="dealerDiscont" class='toggle-label-checkbox'>
                                            <div className='unit parcent'   onClick={e => this.props.TaxDepositCalculation('%','down_payment_type',"type") }>%</div>   
                                            <div className='unit dollar'   onClick={e => this.props.TaxDepositCalculation('$','down_payment_type',"type") }>$</div>
                                          </label>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className='col-auto'>
                                  <div className='price-inline'>
                                        <span className='price-item price price-primary'>${(this.props.const_var.post_data.building != undefined) ? this.props.const_var.post_data.building.down_payment_total : 0}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className='card-bottom-pills'>
                            {(this.props.const_var.post_data.building != undefined && this.props.const_var.post_data.building.custom_insulation_down_payment_total != undefined && this.props.const_var.post_data.building.custom_insulation_down_payment_total > 0) ?
                              <>
                                <div class='form-group'>        
                                  <div class='control-label-bar'>
                                    <label class='control-label'>Insulation Deposit</label>
                                    <div class='control-label-action'>
                                      <div className="price-box-type-2">
                                        {((this.props.const_var.post_data.building != undefined)) ?
                                          <span>${(this.props.const_var.post_data.building != undefined) ? this.props.const_var.post_data.building.custom_insulation_down_payment_total : 0}</span>
                                          : null
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <div className='row align-items-center'>
                                    <div className='col-6'>
                                      <div class="input-group floating-label-input">
                                        <TextField                                           
                                          name="quantity"
                                          value={(this.props.const_var.post_data.building != undefined) ? this.props.const_var.post_data.building.custom_insulation_down_payment_rate : 0}
                                          onKeyUp={e => validate.numericCheckwithDecimalVal(e)}
                                          onChange={e => this.props.TaxDepositCalculation(e.target.value, 'custom_insulation_down_payment_rate', "quantity")}
                                        />
                                        <div class="input-group-append">
                                          <span class="input-group-text">                                      
                                            <div className='toggle-checkgroup'>
                                              <input type="checkbox" id="overHeadInsultion" class="toggle-checkbox" checked={this.props.const_var.post_data.building.custom_insulation_down_payment_type !== "per" ? true : false}/>
                                              <label for="overHeadInsultion" class='toggle-label-checkbox'>
                                                <div className='unit parcent'  onClick={e => this.props.TaxDepositCalculation('%','custom_insulation_down_payment_type',"type") }>%</div>   
                                                <div className='unit dollar'  onClick={e => this.props.TaxDepositCalculation('$','custom_insulation_down_payment_type',"type") }>$</div>
                                              </label>
                                            </div>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='col-auto'>
                                      <div className='price-inline'>
                                        {/* <span className='price-item price price-default'><del>$821.90</del></span> */}
                                        <span className='price-item price price-primary'>${(this.props.const_var.post_data.building!=undefined)?this.props.const_var.post_data.building.custom_insulation_down_payment_total:0}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>                                 
                              </>
                              : null
                            }
                            {
                              (this.props.const_var.post_data.building != undefined && this.props.const_var.post_data.building.custom_overhead_down_payment_total != undefined && this.props.const_var.post_data?.building?.custom_overhead_down_payment_total > 0) ?
                                <>
                                  <div class='form-group'>        
                                    <div class='control-label-bar'>
                                      <label class='control-label'>{/* Overhead  */}Door Deposit</label>
                                    </div>
                                    <div className='row align-items-center'>
                                      <div className='col-6'>
                                        <div class="input-group floating-label-input">
                                          <TextField                                            
                                            name="quantity"
                                            value={(this.props.const_var.post_data.building != undefined) ? this.props.const_var.post_data.building.custom_overhead_down_payment_rate : 0}
                                            onKeyUp={e => validate.numericCheckwithDecimalVal(e)}
                                            onChange={e => this.props.TaxDepositCalculation(e.target.value, 'custom_overhead_down_payment_rate', "quantity")}
                                          />
                                          <div class="input-group-append">
                                            <span class="input-group-text">                                      
                                              <div className='toggle-checkgroup'>
                                                <input type="checkbox" id="overHeadDeopsit" class="toggle-checkbox" checked={this.props.const_var.post_data.building.custom_overhead_down_payment_type !== "per" ? true : false}/>
                                                <label for="overHeadDeopsit" class='toggle-label-checkbox'>
                                                  <div className='unit parcent' onClick={e => this.props.TaxDepositCalculation('%','custom_overhead_down_payment_type',"type") }>%</div>   
                                                  <div className='unit dollar' onClick={e => this.props.TaxDepositCalculation('$','custom_overhead_down_payment_type',"type") }>$</div>
                                                </label>
                                              </div>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className='col-auto'>
                                        <div className='price-inline'>
                                          {/* <span className='price-item price price-default'><del>$821.90</del></span> */}
                                          <span className='price-item price price-primary'>${(this.props.const_var.post_data.building != undefined) ? this.props.const_var.post_data.building.custom_overhead_down_payment_total : 0}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>                                  
                                </>
                                : null
                            }

                            <div class='form-group'>
                              <label class='control-label'>Dealer Discount</label>  
                              <div class='control-label-action'>
                                <div className="price-box-type-2">
                                  <span>${(this.props.const_var.post_data.building != undefined && this.props.const_var.post_data.building.down_payment_discount_total != undefined) ? this.props.const_var.post_data.building.down_payment_discount_total : 0}</span>                                    
                                </div>                                
                              </div>                              
                              <div className='row align-items-center'>
                                <div className='col-6'>
                                  <div class={"input-group floating-label-input"+ (!this.props.const_var.is_price_edit ? ' disable-edit' : '')}>
                                    <TextField                                       
                                        name="quantity"
                                        value={(this.props.const_var.post_data.building != undefined && this.props.const_var.post_data.building.down_payment_total > 0) ? this.props.const_var.post_data.building.down_payment_discount_rate: 0}
                                        onKeyUp={e => validate.numericCheckwithDecimalVal(e)}
                                        onChange={e => this.props.TaxDepositCalculation(e.target.value, 'down_payment_discount_rate', "quantity")}
                                      />
                                    <div class="input-group-append">
                                      <span class="input-group-text">                                      
                                        <div className='toggle-checkgroup'>
                                          <input type="checkbox" id="dealerDis" class="toggle-checkbox" checked={this.props.const_var.post_data.building.down_payment_discount_type !== "per" ? true : false}/>
                                          <label for="dealerDis" class='toggle-label-checkbox'>
                                            <div className='unit parcent' onClick={e => this.props.TaxDepositCalculation('%','down_payment_discount_type',"type")}>%</div>   
                                            <div className='unit dollar' onClick={e => this.props.TaxDepositCalculation('$','down_payment_discount_type',"type")}>$</div>
                                          </label>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className='col-auto'>
                                  <div className='price-inline'>
                                  <span className='price-item price price-default'><del>{dealer_discount ? <Deposit /> : null}</del></span>
                                  <span className='price-item price price-primary'>{dealer_discount ?<DepositDiscount isFor="DealerDiscount" /> : null}</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class='form-group'>        
                              <div class='control-label-bar'>
                                <label class='control-label'>Title of the Discount</label>
                              </div>
                              <div className="floating-label-input">
                                <TextField
                                  maxLength="20"
                                  name="discounttypename"
                                  value={this.props.const_var.dealer_discount_label}
                                  onChange={e => this.props.TaxDepositCalculation(e.target.value, 'discounttypename', "")}
                                />
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>

                    <Card className='card-pills'>
                      <Card.Header className='card-headers-pills'>
                        <Accordion.Toggle as={Card.Header} eventKey="financerto" className='accordion-toggle-pills' onClick={(e) => this.props.handleAccordion(e)}>
                          <span className='card-pills-title'>Payment Mode</span>
                          <span className='card-pills-action'><i className='icon icon-plus-ico'></i></span>
                        </Accordion.Toggle>
                      </Card.Header>

                      <Accordion.Collapse eventKey="financerto" className='accordion-collapse-pills'>
                        <Card.Body className='card-body-pills'>
                          <div className='card-bottom-pills'>
                            <div className='form-group'>
                              {
                                (this.props.const_var.crmSetting.main_domain_url != undefined && this.props.const_var.crmSetting.main_domain_url == 'eaglebuildings.com') ?
                                <div className='radio-group'>
                                  <Radio
                                    label="COD"
                                    value={this.props.params.paymentmode}
                                    checked={this.props.params.paymentmode == "cod" ? true : false}
                                    name="cod"
                                    onChange={e => this.props.updatePaymentOption('cod')}
                                  />
                                </div> :
                                <div className='radio-group'>
                                  <Radio
                                    label="Cash"
                                    value={this.props.params.paymentmode}
                                    checked={this.props.params.paymentmode == "cash" ? true : false}
                                    name="cash"
                                    onChange={e => this.props.updatePaymentOption('cash')}
                                  />
                                </div>
                              }
                              <div className='radio-group'>
                                <Radio
                                  label="Financing"
                                  value={this.props.params.paymentmode}
                                  checked={this.props.params.paymentmode == "finance" ? true : false}
                                  name="finance"
                                  onChange={e => this.props.updatePaymentOption('finance')}
                                />
                              </div>
                              <div className={(this.props.params.paymentmode == "finance" ) ? 'drop-info drop-info-md mt-2' : 'drop-info drop-info-md d-none mt-2'}>
                                <div className='form-group'>
                                  <label className='control-label'>Finance Company</label>
                                  <div className={(this.props.displayerrorMessage == undefined) ? "floating-label-input" : "floating-label-input invalid-input"}>
                                    <TextField
                                      name="finance_company"
                                      value={this.props.params.paymentmode != "cash" ? this.props.const_var.paymentOptionObj[this.props.params.paymentmode].finance_company : ''}
                                      onChange={e => this.props.updatePaymentOption(e.target.value, 'finance_company')}
                                    />
                                    <span className="error-icon icon-info-ico"></span>
                                    <div className="errorMessage" id="fnameErrorMessage">{this.props.displayerrorMessage != undefined ? this.props.displayerrorMessage.finance_company : ''}</div>
                                  </div>
                                </div>                              

                                <div className='row gutters-5'>
                                  <div className='col-6'>
                                    <div className='form-group'>
                                      <label className='control-label'>Application ID</label>
                                      <div className="floating-label-input">
                                        <TextField
                                          name="application_id"
                                          value={this.props.params.paymentmode != "cash" ? this.props.const_var.paymentOptionObj[this.props.params.paymentmode].application_id : ''}
                                          onChange={e => this.props.updatePaymentOption(e.target.value, 'application_id')}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className='col-6'>
                                    <div className='form-group'>
                                      <label className='control-label'>Plan No.</label>
                                      <div className="floating-label-input">
                                        <TextField
                                          name="quantity"
                                          value={this.props.params.paymentmode != "cash" ? this.props.const_var.paymentOptionObj[this.props.params.paymentmode].plan_no : ''}
                                          onChange={e => this.props.updatePaymentOption(e.target.value, 'plan_no')}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className='row gutters-5'>
                                  <div className='col-6'>
                                    <div className='form-group'>
                                      <label className='control-label'>Expiry Date</label>
                                      <div className="floating-label-input date-picker-input">
                                        <TextField
                                          type="date"
                                          name="expiry_date"
                                          value={this.props.params.paymentmode != "cash" ? this.props.const_var.paymentOptionObj[this.props.params.paymentmode].expiry_date : ''}
                                          onChange={e => this.props.updatePaymentOption(e.target.value, 'expiry_date')}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>                                
                              </div>
                              <div className={(this.props.const_var.crmSetting.main_domain_url != undefined && this.props.const_var.crmSetting.main_domain_url == 'eaglebuildings.com') ? 'radio-group' : 'radio-group'}>
                                <Radio
                                  label="RTO"
                                  value={this.props.params.paymentmode}
                                  checked={this.props.params.paymentmode == "rto" ? true : false}
                                  name="rto"
                                  onChange={e => this.props.updatePaymentOption('rto')}
                                />
                              </div>
                              <div className={( this.props.params.paymentmode == "rto") ? 'drop-info drop-info-md mt-2' : 'drop-info drop-info-md d-none mt-2'}>
                                <div className='form-group'>
                                  <label className='control-label'>Finance Company</label>
                                  <div className={(this.props.displayerrorMessage == undefined) ? "floating-label-input" : "floating-label-input invalid-input"}>
                                    <TextField
                                      name="finance_company"
                                      value={this.props.params.paymentmode != "cash" ? this.props.const_var.paymentOptionObj[this.props.params.paymentmode].finance_company : ''}
                                      onChange={e => this.props.updatePaymentOption(e.target.value, 'finance_company')}
                                    />
                                    <span className="error-icon icon-info-ico"></span>
                                    <div className="errorMessage" id="fnameErrorMessage">{this.props.displayerrorMessage != undefined ? this.props.displayerrorMessage.finance_company : ''}</div>
                                  </div>
                                </div>                              

                                <div className='row gutters-5'>
                                  <div className='col-6'>
                                    <div className='form-group'>
                                      <label className='control-label'>Application ID</label>
                                      <div className="floating-label-input">
                                        <TextField
                                          name="application_id"
                                          value={this.props.params.paymentmode != "cash" ? this.props.const_var.paymentOptionObj[this.props.params.paymentmode].application_id : ''}
                                          onChange={e => this.props.updatePaymentOption(e.target.value, 'application_id')}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className='col-6'>
                                    <div className='form-group'>
                                      <label className='control-label'>Plan No.</label>
                                      <div className="floating-label-input">
                                        <TextField
                                          name="quantity"
                                          value={this.props.params.paymentmode != "cash" ? this.props.const_var.paymentOptionObj[this.props.params.paymentmode].plan_no : ''}
                                          onChange={e => this.props.updatePaymentOption(e.target.value, 'plan_no')}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className='row gutters-5'>
                                  <div className='col-6'>
                                    <div className='form-group'>
                                      <label className='control-label'>Expiry Date</label>
                                      <div className="floating-label-input date-picker-input">
                                        <TextField
                                          type="date"
                                          name="expiry_date"
                                          value={this.props.params.paymentmode != "cash" ? this.props.const_var.paymentOptionObj[this.props.params.paymentmode].expiry_date : ''}
                                          onChange={e => this.props.updatePaymentOption(e.target.value, 'expiry_date')}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>                                
                              </div>
                              {
                                (this.props.const_var.crmSetting.main_domain_url != undefined && this.props.const_var.crmSetting.main_domain_url == 'eaglebuildings.com') ?
                                null :
                                <div className='radio-group'>
                                  <Radio
                                    label="Certified Check"
                                    value={this.props.params.paymentmode}
                                    checked={this.props.params.paymentmode == "certified_check" ? true : false}
                                    name="certified_check"
                                    onChange={e => this.props.updatePaymentOption('certified_check')}
                                  />
                                </div>
                              }
                              <div className='radio-group'>
                                <Radio
                                  label="Money Order"
                                  value={this.props.params.paymentmode}
                                  checked={this.props.params.paymentmode == "money_order" ? true : false}
                                  name="money_order"
                                  onChange={e => this.props.updatePaymentOption('money_order')}
                                />
                              </div>
                            </div>

                            
                          </div>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
                <div className='read-box d-none'>
                  <ReadMore>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</ReadMore>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    );
  }
}


const mapStateToProps = (state) => {
  return { ...state.reducer, ...state.orderExtrasReducer }
}

export default connect(
  mapStateToProps,
  //mapDispachToProps,
  actionCreator
)(TaxDeposit);


